import React, { useMemo, useState } from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import GenericInsert from './GenericInsert';
import GenericEdit from './GenericEdit';

const TABLE_OPTIONS = [
  { key: 'builder', label: 'Builders', tableName: 'builder' },
  { key: 'district', label: 'District', tableName: 'district' },
  { key: 'employee', label: 'Employees', tableName: 'employee' },
  { key: 'fixture', label: 'Fixtures', tableName: 'material_type' },
  { key: 'manufacturer', label: 'Manufacturers', tableName: 'material_manufacturer' },
  { key: 'material-template', label: 'Material Templates', tableName: 'material_template' },
  { key: 'municipality', label: 'Municipality', tableName: 'municipality' },
  { key: 'neighborhood', label: 'Neighborhoods', tableName: 'neighborhood' },
  { key: 'plan-number', label: 'Plan Numbers', tableName: 'plan_number' },
  { key: 'material-room', label: 'Rooms', tableName: 'material_room' },
  { key: 'superintendent', label: 'Superintendents', tableName: 'superintendent' },
];

const TableAdmin = () => {
  const [selectedTableKey, setSelectedTableKey] = useState(TABLE_OPTIONS[0].key);
  const [insertTrigger, setInsertTrigger] = useState(false);

  const selectedOption = useMemo(
    () => TABLE_OPTIONS.find((option) => option.key === selectedTableKey),
    [selectedTableKey]
  );

  const handleInsert = () => {
    setInsertTrigger((prev) => !prev);
  };

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 2, fontWeight: 'bold' }}>
        Table Admin
      </Typography>
      <FormControl sx={{ minWidth: 320, mb: 2 }}>
        <InputLabel id="table-admin-select-label">Table</InputLabel>
        <Select
          labelId="table-admin-select-label"
          id="table-admin-select"
          value={selectedTableKey}
          label="Table"
          onChange={(event) => setSelectedTableKey(event.target.value)}
        >
          {TABLE_OPTIONS.map((option) => (
            <MenuItem key={option.key} value={option.key}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {selectedOption && (
        <>
          <GenericInsert
            key={`table-admin-insert-${selectedOption.tableName}`}
            tableName={selectedOption.tableName}
            onInsert={handleInsert}
          />
          <br />
          <GenericEdit
            key={`table-admin-edit-${selectedOption.tableName}`}
            tableName={selectedOption.tableName}
            onInsert={insertTrigger}
          />
        </>
      )}
    </Box>
  );
};

export default TableAdmin;
